import { Layer } from "../tile.js";
import { Actor, SlidingState } from "../actor.js";
import { actorDB, cc1BootNameList, getTagFlag, keyNameList } from "../const.js";
import { LitTNT, RollingBowlingBall } from "./monsters.js";
import { Explosion } from "./animation.js";
import { SteelWall } from "./walls.js";
export class Item extends Actor {
    constructor(level, pos, customData, wires) {
        super(level, pos, customData, wires);
        this.destination = 2 /* ItemDestination.ITEM */;
        if (new.target.carrierTags) {
            this.carrierTags = new.target.carrierTags;
        }
    }
    hasItemMod() {
        var _a;
        if ((_a = this.tile[Layer.ITEM_SUFFIX]) === null || _a === void 0 ? void 0 : _a.hasTag("ignoreItem"))
            return true;
        return false;
    }
    blocks(other) {
        return (!this.hasItemMod() &&
            !other.hasTag("can-pickup-items") &&
            !other.hasTag("can-stand-on-items") &&
            !other.hasTag("playable"));
    }
    ignores(_other) {
        return this.hasItemMod();
    }
    getLayer() {
        return Layer.ITEM;
    }
    pickup(other) {
        var _a, _b;
        if (other.hasTag("can-stand-on-items") ||
            (this.shouldBePickedUp && !this.shouldBePickedUp(other)) ||
            this.hasItemMod())
            return false;
        this.destroy(other, null);
        if (other.hasTag("playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("item get");
        }
        switch (this.destination) {
            case 1 /* ItemDestination.KEY */:
                if (!other.inventory.keys[this.id])
                    other.inventory.keys[this.id] = { amount: 0, type: this };
                other.inventory.keys[this.id].amount++;
                other.inventory.keys[this.id].amount %= 256;
                break;
            case 2 /* ItemDestination.ITEM */:
                if (this.level.cc1Boots) {
                    if (!cc1BootNameList.includes(this.id) ||
                        other.inventory.items.some(item => item.id === this.id))
                        break;
                }
                other.inventory.items.unshift(this);
                if (other.inventory.items.length > other.inventory.itemMax) {
                    if (!other.dropItem())
                        other.dropItemN(0, true);
                }
                break;
        }
        (_b = this.onPickup) === null || _b === void 0 ? void 0 : _b.call(this, other);
        if (this.carrierTags) {
            for (const prop in this.carrierTags) {
                other[prop] |= this.carrierTags[prop];
            }
        }
        return true;
    }
    actorCompletelyJoined(other) {
        this.pickup(other);
    }
}
Item.tags = ["item"];
export class EChipPlus extends Item {
    hasItemMod() {
        return false;
    }
    constructor(level, position, customData, direction) {
        super(level, position, customData, direction);
        this.id = "echipPlus";
        this.destination = 0 /* ItemDestination.NONE */;
        level.chipsTotal++;
    }
    shouldBePickedUp(other) {
        return other.hasTag("real-playable");
    }
    onPickup() {
        this.level.chipsLeft = Math.max(0, this.level.chipsLeft - 1);
    }
}
actorDB["echipPlus"] = EChipPlus;
export class EChip extends EChipPlus {
    constructor(level, position, customData, direction) {
        super(level, position, customData, direction);
        this.id = "echip";
        level.chipsLeft++;
        level.chipsRequired++;
    }
}
actorDB["echip"] = EChip;
export class Key extends Item {
    constructor() {
        super(...arguments);
        this.destination = 1 /* ItemDestination.KEY */;
    }
}
// TODO Turn this into a factory too
export class KeyRed extends Key {
    constructor() {
        super(...arguments);
        this.id = "keyRed";
        this.blocks = undefined;
    }
    ignores(other) {
        return !other.hasTag("playable");
    }
    keyUsed(other) {
        if (other.hasTag("can-reuse-key-red"))
            other.inventory.keys[this.id].amount++;
    }
}
actorDB["keyRed"] = KeyRed;
keyNameList.push("keyRed");
export class KeyBlue extends Key {
    constructor() {
        super(...arguments);
        this.id = "keyBlue";
        this.blocks = undefined;
    }
    keyUsed(other) {
        if (other.hasTag("can-reuse-key-blue"))
            other.inventory.keys[this.id].amount++;
    }
}
actorDB["keyBlue"] = KeyBlue;
keyNameList.push("keyBlue");
export class KeyYellow extends Key {
    constructor() {
        super(...arguments);
        this.id = "keyYellow";
    }
    keyUsed(other) {
        if (other.hasTag("can-reuse-key-yellow"))
            other.inventory.keys[this.id].amount++;
    }
}
actorDB["keyYellow"] = KeyYellow;
keyNameList.push("keyYellow");
export class KeyGreen extends Key {
    constructor() {
        super(...arguments);
        this.id = "keyGreen";
    }
    keyUsed(other) {
        if (other.hasTag("can-reuse-key-green"))
            other.inventory.keys[this.id].amount++;
    }
}
actorDB["keyGreen"] = KeyGreen;
keyNameList.push("keyGreen");
export class BootIce extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootIce";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    onPickup(other) {
        if (other.hasTag("weirdly-ignores-ice")) {
            this.carrierTags = { tags: getTagFlag("super-weirdly-ignores-ice") };
        }
        else {
            this.carrierTags = { ignoreTags: getTagFlag("ice") };
            // Indeed, a hack, but I really don't want to ever calculate the sliding state automatically
            if (other.slidingState === SlidingState.STRONG)
                other.slidingState = SlidingState.NONE;
        }
        /* if (
            other.getCompleteTags("ignoreTags").includes("ice") &&
            !other.getCompleteTags("ignoreTags", this).includes("ice")
        )
            other.slidingState = SlidingState.NONE */
    }
}
BootIce.carrierTags = { ignoreTags: ["ice"] };
BootIce.extraTagProperties = ["extraTags"];
BootIce.extraTags = ["super-weirdly-ignores-ice"];
actorDB["bootIce"] = BootIce;
cc1BootNameList.push("bootIce");
export class BootForceFloor extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootForceFloor";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    onPickup(other) {
        // Indeed, a hack, but I really don't want to ever calculate the sliding state automatically
        if (other.slidingState === SlidingState.WEAK) {
            other.slidingState = SlidingState.NONE;
        }
    }
}
BootForceFloor.carrierTags = { ignoreTags: ["force-floor"] };
actorDB["bootForceFloor"] = BootForceFloor;
cc1BootNameList.push("bootForceFloor");
export class BootFire extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootFire";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    // Double-ignore thing for the ghost
    onCarrierCompleteJoin(carrier) {
        if (!carrier.hasTag("double-item-remove"))
            return;
        for (const actor of carrier.tile.allActors) {
            if (actor.hasTag("fire") && actor.hasTag("boot-removable")) {
                actor.destroy(null, null);
            }
        }
    }
}
BootFire.carrierTags = { ignoreTags: ["fire"] };
actorDB["bootFire"] = BootFire;
cc1BootNameList.push("bootFire");
export class BootWater extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootWater";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
BootWater.carrierTags = { ignoreTags: ["water"], collisionIgnoreTags: ["water"] };
actorDB["bootWater"] = BootWater;
cc1BootNameList.push("bootWater");
export class BootDirt extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootDirt";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    onPickup(other) {
        if (other.hasTag("playable")) {
            this.carrierTags = { collisionIgnoreTags: getTagFlag("filth") };
        }
        else {
            this.carrierTags = { collisionIgnoreTags: BigInt(0) };
        }
    }
    // Double-ignore thing for the ghost
    onCarrierCompleteJoin(carrier) {
        if (!carrier.hasTag("double-item-remove"))
            return;
        for (const actor of carrier.tile.allActors) {
            if (actor.hasTag("filth") && actor.hasTag("boot-removable")) {
                actor.destroy(null, null);
            }
        }
    }
}
BootDirt.carrierTags = { collisionIgnoreTags: ["filth"] };
actorDB["bootDirt"] = BootDirt;
export class GoronBraslet extends Item {
    constructor() {
        super(...arguments);
        this.id = "goronBraslet";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
GoronBraslet.carrierTags = { pushTags: ["wall"] };
actorDB["goronBraslet"] = GoronBraslet;
export class Helmet extends Item {
    constructor() {
        super(...arguments);
        this.id = "helmet";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
Helmet.carrierTags = { tags: ["ignore-default-monster-kill"] };
actorDB["helmet"] = Helmet;
export class BonusFlag extends Item {
    constructor() {
        super(...arguments);
        this.id = "bonusFlag";
        this.destination = 0 /* ItemDestination.NONE */;
    }
    hasItemMod() {
        return false;
    }
    onPickup(carrier) {
        if (carrier.hasTag("real-playable"))
            if (this.customData.startsWith("*"))
                this.level.bonusPoints *= parseInt(this.customData.substr(1));
            else
                this.level.bonusPoints += parseInt(this.customData);
    }
}
BonusFlag.tags = ["bonusFlag"];
actorDB["bonusFlag"] = BonusFlag;
export class TNT extends Item {
    constructor() {
        super(...arguments);
        this.id = "tnt";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    actorLeft(other) {
        if (!other.hasTag("real-playable"))
            return;
        this.destroy(null, null);
        const lit = new LitTNT(this.level, this.tile.position);
        lit.inventory.itemMax = other.inventory.itemMax;
        lit.inventory.items = other.inventory.items.map(item => {
            const rootTile = this.level.field[0][0];
            const rootActor = rootTile[item.layer];
            delete rootTile[item.layer];
            const nItem = new actorDB[item.id](this.level, [0, 0], item.customData);
            nItem.pickup(lit);
            if (rootActor !== undefined) {
                rootTile[item.layer] = rootActor;
            }
            return nItem;
        });
        for (const keyType in other.inventory.keys)
            lit.inventory.keys[keyType] = { ...other.inventory.keys[keyType] };
        lit.recomputeTags();
    }
}
actorDB["tnt"] = TNT;
export class SecretEye extends Item {
    constructor() {
        super(...arguments);
        this.id = "secretEye";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
SecretEye.carrierTags = { tags: ["can-see-secrets"] };
actorDB["secretEye"] = SecretEye;
export class RailroadSign extends Item {
    constructor() {
        super(...arguments);
        this.id = "railroadSign";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
RailroadSign.carrierTags = {
    tags: ["ignores-railroad-redirect"],
    collisionIgnoreTags: ["railroad"],
};
actorDB["railroadSign"] = RailroadSign;
export class BowlingBall extends Item {
    constructor() {
        super(...arguments);
        this.id = "bowlingBall";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
    onDrop(dropper) {
        dropper.tile.removeActors(dropper);
        const rollingGuy = this.replaceWith(RollingBowlingBall);
        if (rollingGuy._internalStep(dropper.direction))
            rollingGuy.cooldown--;
        // Hello animation from rolling bowling ball movement failure, please die so my dropper can go back
        const movable = dropper.tile[Layer.MOVABLE];
        if (movable instanceof Explosion)
            movable.destroy(null, null);
        dropper.tile.addActors(dropper);
    }
}
actorDB["bowlingBall"] = BowlingBall;
export class TimeBonus extends Item {
    constructor() {
        super(...arguments);
        this.id = "timeBonus";
        this.destination = 0 /* ItemDestination.NONE */;
    }
    hasItemMod() {
        return false;
    }
    shouldBePickedUp(other) {
        return other.hasTag("real-playable");
    }
    onPickup() {
        this.level.timeLeft += 60 * 10;
    }
}
actorDB["timeBonus"] = TimeBonus;
export class TimePenalty extends Item {
    constructor() {
        super(...arguments);
        this.id = "timePenalty";
        this.destination = 0 /* ItemDestination.NONE */;
    }
    hasItemMod() {
        return false;
    }
    shouldBePickedUp(other) {
        return other.hasTag("real-playable");
    }
    onPickup() {
        this.level.timeLeft -= 60 * 10;
        if (this.level.timeLeft < 1)
            this.level.timeLeft = 1;
    }
}
actorDB["timePenalty"] = TimePenalty;
export class TimeToggle extends Item {
    constructor() {
        super(...arguments);
        this.id = "timeToggle";
        this.destination = 0 /* ItemDestination.NONE */;
    }
    hasItemMod() {
        return false;
    }
    shouldBePickedUp() {
        return false;
    }
    actorCompletelyJoined(other) {
        if (!other.hasTag("playable"))
            return;
        this.level.timeFrozen = !this.level.timeFrozen;
    }
}
actorDB["timeToggle"] = TimeToggle;
export class SpeedBoots extends Item {
    constructor() {
        super(...arguments);
        this.id = "bootSpeed";
    }
    carrierSpeedMod(_actor, mult) {
        return mult === 1 ? 2 : 1;
    }
}
actorDB["bootSpeed"] = SpeedBoots;
export class LightningBolt extends Item {
    constructor() {
        super(...arguments);
        this.id = "lightningBolt";
    }
    onCarrierJoin(carrier) {
        if (carrier.oldTile && !carrier.oldTile.hasLayer(Layer.STATIONARY))
            carrier.oldTile.poweringWires = 0;
    }
    onCarrierCompleteJoin(carrier) {
        if (!carrier.tile.hasLayer(Layer.STATIONARY))
            carrier.tile.poweringWires = carrier.tile.wires;
    }
    onDrop(carrier) {
        if (!carrier.tile.hasLayer(Layer.STATIONARY))
            carrier.tile.poweringWires = 0;
    }
    onCarrierDestroyed(carrier) {
        if (!carrier.tile.hasLayer(Layer.STATIONARY))
            carrier.tile.poweringWires = 0;
    }
}
actorDB["lightningBolt"] = LightningBolt;
export class Hook extends Item {
    constructor() {
        super(...arguments);
        this.id = "hook";
        this.destination = 2 /* ItemDestination.ITEM */;
    }
}
Hook.carrierTags = { tags: ["pulling"] };
actorDB["hook"] = Hook;
export class Foil extends Item {
    constructor() {
        super(...arguments);
        this.id = "foil";
    }
    onCarrierBump(carrier, bumpee) {
        if (!bumpee.hasTag("tinnable"))
            return;
        bumpee.replaceWith(SteelWall);
    }
}
actorDB["foil"] = Foil;
export class Bribe extends Item {
    constructor() {
        super(...arguments);
        this.id = "bribe";
    }
}
Bribe.tags = ["item", "bribe"];
actorDB["bribe"] = Bribe;
//# sourceMappingURL=items.js.map